import DocService from "../services/doc.service";
// import moment from 'moment';

export const doc = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getDocCoverPageDownload({ commit }, { loanNumber, docCoverPage}){
      return DocService.getDocCoverPageDownload(loanNumber, docCoverPage).then(
        resp => {
          commit('dummy', "getDocCoverPageDownload - success");
          return Promise.resolve(resp);
        },
        error => {
          commit('dummy', "getDocCoverPageDownload - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    }
  }
};